export default __webpack_public_path__ + "static/media/Coffee.7342e0e8.jpg";